import { Announcement } from "../../__generated__/graphql";
import { useMutation } from "@apollo/client";
import { Controller, useForm } from "react-hook-form";
import { Button, Container, TextField } from "@mui/material";
import "react-image-crop/dist/ReactCrop.css";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { PageContainer } from "../../components/PageContainer";
import { ButtonContainer } from "../../components/ButtonContainer";
import {
  CREATE_UPDATE_ANNOUNCEMENT,
  DELETE_ANNOUNCEMENT,
  GET_ANNOUNCEMENTS,
} from "./graphql";
import { ZonedDateTimePicker } from "../../components/ZonedDateTimePicker";
import dayjs from "dayjs";
import { confirmAlert } from "react-confirm-alert";

const schema = yup
  .object({
    name: yup.string().required(),
    availabilityDate: yup.string().nullable(),
  })
  .required();

export interface ICreateUpdateAnnouncement {
  announcement: Announcement | undefined | null;
  editionId: string;
}
export const CreateUpdateForm = ({
  announcement,
  editionId,
}: ICreateUpdateAnnouncement) => {
  const navigate = useNavigate();
  const [createUpdateAnnouncement, { loading: updateLoading, error }] =
    useMutation(CREATE_UPDATE_ANNOUNCEMENT, {
      onCompleted: (result) => {
        toast("announcement saved");
        const announcementId = result.createUpdateAnnouncement?.id;
        if (announcementId) {
          navigate(`/announcement/${announcementId}`);
        } else {
          navigate(-1);
        }
      },
      onError: (error) => {
        toast(JSON.stringify(error));
      },
      refetchQueries: [
        {
          query: GET_ANNOUNCEMENTS,
          variables: { editionId },
        },
        "festivalEdition",
      ],
      awaitRefetchQueries: true,
    });

  const handleDelete = () => {
    if (announcement && announcement?.bands?.length > 0) {
      confirmAlert({
        title: "Unable to delete announcement",
        message:
          "Please remove all bookings before attempting to delete this announcement.",
        buttons: [{ label: "Ok" }],
      });
      return;
    }

    confirmAlert({
      title: "Delete this Announcemnt?",
      message: "Are you sure? this can't be undone",
      buttons: [
        {
          label: "Yes",
          onClick: () =>
            deleteAnnouncement({
              variables: { announcementId: announcement!.id },
            }),
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const [deleteAnnouncement] = useMutation(DELETE_ANNOUNCEMENT, {
    onCompleted: (result) => {
      toast("announcement deleted");
      navigate(-1);
    },
    onError: (error) => {
      toast(JSON.stringify(error));
    },
    refetchQueries: [
      {
        query: GET_ANNOUNCEMENTS,
        variables: { editionId },
      },
      "festivalEdition",
    ],
    awaitRefetchQueries: true,
  });
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { ...announcement },
  });

  const onSubmit = (val: any) => {
    const { name, availabilityDate } = val;

    createUpdateAnnouncement({
      variables: {
        id: announcement?.id,
        editionId,
        name,
        availabilityDate: availabilityDate,
      },
    });
  };

  return (
    <PageContainer title="Create/Update Announcement">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Container style={{ flexDirection: "column", display: "flex" }}>
          <TextField
            id="outlined-basic"
            label="Name"
            variant="outlined"
            {...register("name")}
          />
          <p>{errors.name?.message}</p>
          <Controller
            control={control}
            name="availabilityDate"
            render={({ field: { onChange, value } }) => {
              return (
                <ZonedDateTimePicker
                  format="YYYY/MM/DD HH:mm"
                  ampm={false}
                  label="Availability date"
                  defaultValue={value ? dayjs(value) : null}
                  // @ts-ignore
                  onChange={onChange}
                />
              );
            }}
          />
          <p>{errors.availabilityDate?.message}</p>
          <ButtonContainer>
            <Button type="submit" variant="contained">
              Save
            </Button>
            {announcement?.id &&<Button variant="contained" color="error" onClick={handleDelete}>
              Delete announcement
            </Button>}
          </ButtonContainer>
        </Container>
      </form>
    </PageContainer>
  );
};
